module.exports = __webpack_public_path__ + "static/media/yes@3x.3e50fe59.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/yes@3x.png
// module id = 751
// module chunks = 0